import { Box, IconButton, Typography } from '@mui/material';
import { Button, FlexContainer, IconLibrary } from '@act/storybook';
import { NeedsCategoryDto } from '@act/shared/data-transfer-objects';
import { GoalsSidePanel } from './GoalsSidePanel';
import { ReactNode } from 'react';

export interface LearnMoreContentProps {
  selectedIssueZCode?: ReactNode;
  selectedCategory?: NeedsCategoryDto;
  open: boolean;
  setOpen: (open: boolean) => void;
}

export const LearnMoreContent = ({
  open,
  setOpen,
  selectedIssueZCode,
  selectedCategory,
}: LearnMoreContentProps) => {
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <GoalsSidePanel
      open={open}
      titleContent={
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'flex-start',
            gap: '16px',
          }}
        >
          <IconButton onClick={handleClose}>
            <IconLibrary iconName="ArrowLeft" size={32} weight="regular" />
          </IconButton>
          <Typography variant="titleLarge" sx={{ alignSelf: 'center' }}>
            {selectedCategory?.label}
          </Typography>
        </Box>
      }
      content={
        <FlexContainer direction="column" gap={2}>
          <Box>{selectedIssueZCode}</Box>
        </FlexContainer>
      }
      footerContent={
        <Box>
          <Button onClick={handleClose}>Close</Button>
        </Box>
      }
    />
  );
};
